import { useMemo } from 'react';
import { usePersonalizedContent } from './usePersonalizedContent';
export const usePersonalizedFeatures = () => {
  const {
    data,
    isEnabled,
    isLoading
  } = usePersonalizedContent();
  const byFamily = useMemo(() => {
    var _data$features;
    const map = new Map();
    const items = data == null || (_data$features = data.features) == null ? void 0 : _data$features.items;
    if (Array.isArray(items)) {
      items.forEach(item => map.set(item.productFamilyId, item.featureRows));
    }
    return map;
  }, [data]);
  return {
    getFeatureRows: productFamilyId => isEnabled && productFamilyId ? byFamily.get(productFamilyId) : undefined,
    isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedFeatures.js.map